import React from 'react';
import {Button, Group, Modal, Text, Textarea} from "@mantine/core";
import {Opportunity, OpportunityApproverRoles} from "@repo/services";
import {IconCircleX, IconThumbUp} from "@tabler/icons-react";
import {UseFormReturnType} from "@mantine/form";

interface OpportunityApproveModalProps {
    form: UseFormReturnType<any>;
    approveModalOpen: boolean;
    loading: boolean;
    setApproveModalOpen: (value: (((prevState: boolean) => boolean) | boolean)) => void;
    closeApproveModal: () => void;
    opportunityTitle: string;
    handleApprove: (id?: number | null) => void;
}

/**
 * A modal dialog that confirms opportunity approval with a comments field for the approver's justification.
 */
const OpportunityApproveModal = (
    { form, approveModalOpen, loading, setApproveModalOpen, opportunityTitle, handleApprove}: OpportunityApproveModalProps) => {
    return (
        <>
            <Modal opened={approveModalOpen} onClose={() => setApproveModalOpen(false)} title="Confirm Approval" centered>
                <Text>{`You are qualifying transaction "${opportunityTitle}". Please confirm and provide comments below.`}</Text>
                {/*<Text>{`You are qualifying opportunity ${(opportunityToDisplay as Opportunity)?.aimOpportunity}. Please confirm and provide comments below.`}</Text>*/}
                <form>
                    <Textarea
                        mt={20}
                        label="Comments"
                        placeholder="Comments"
                        {...form.getInputProps('comments')}
                    />
                    <Group >
                        <Button
                            color="green"
                            mt={20}
                            rightSection={<IconThumbUp size={14} />}
                            onClick={handleApprove as any}
                            // loading={role === OpportunityApproverRoles.operationsVP
                            //     ? opsQualifyIsLoading
                            //     : ceoQualifyIsLoading
                            // }
                            loading={loading}
                        >
                            Confirm
                        </Button>
                        <Button
                            color="gray"
                            mt={20}
                            rightSection={<IconCircleX size={14} />}
                            onClick={() => setApproveModalOpen(false)}
                        >
                            Close
                        </Button>
                    </Group>
                </form>
            </Modal>
        </>
    );
};

export default OpportunityApproveModal;
